export default __webpack_public_path__ + "static/layout-example-light-11945c0e43f558a637730a322413e8ba0d44eea6d8e4a4d0b2d02569b5c6837e.png";